import React, { memo } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import DownloadLink, { isApiDownloadLink } from './DownloadLink';

// Hoisted so they are not re-created on every streamed token.
const remarkPlugins = [remarkGfm];

const components: Components = {
  // Query results come back as GFM tables; a wrapper gives wide ones a horizontal scroll.
  table: ({ children }) => (
    <div className="chat-md-table">
      <table>{children}</table>
    </div>
  ),
  a: ({ href, children }) =>
    href && isApiDownloadLink(href) ? (
      <DownloadLink href={href}>{children}</DownloadLink>
    ) : (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
};

interface IProps {
  content: string;
}

// An assistant reply. Memoised because the bubble re-renders on every streamed token.
const MarkdownContent = memo(({ content }: IProps) => (
  <div className="chat-md">
    <ReactMarkdown remarkPlugins={remarkPlugins} components={components}>
      {content}
    </ReactMarkdown>
  </div>
));

MarkdownContent.displayName = 'MarkdownContent';

export default MarkdownContent;
